import { LspEmployeesTable } from 'common/components/organisms/LspEmployeeTable/LspEmployeesTable';

export const EmployeesTab = ({ lspId }: { lspId: string }) => {
  return (
    <div data-testid="lsp-employees-tab">
      <LspEmployeesTable lspId={lspId} />
    </div>
  );
};
